module.exports = __webpack_public_path__ + "img/1.b522cdb6.png";